import { render } from "./IconExclamationOutlined.vue?vue&type=template&id=44adcb09"
import script from "./IconExclamationOutlined.vue?vue&type=script&lang=js"
export * from "./IconExclamationOutlined.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/miniapp-property-b2b/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/assets/js/components/Icons/Icons/24/IconExclamationOutlined.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "44adcb09"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('44adcb09', __exports__)) {
    api.reload('44adcb09', __exports__)
  }
  
  module.hot.accept("./IconExclamationOutlined.vue?vue&type=template&id=44adcb09", () => {
    api.rerender('44adcb09', render)
  })

}


export default __exports__